"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSHSPrimaryMethodComponent = void 0;
const account_service_1 = require("../../services/account.service");
const accountsettings_service_1 = require("../../services/accountsettings.service");
const constants = require("../../constants");
class CSHSPrimaryMethodComponent {
    constructor(accountDetailService, accountService) {
        this.accountDetailService = accountDetailService;
        this.accountService = accountService;
        this.classes = 'row col-md-12 mx-0 px-0';
        this.tenantType = constants.tenantType;
    }
    ngOnInit() {
        this.getAccountType();
        this.getPaymentMethod();
        this.canShowBankAccount();
    }
    getAccountType() {
        this.accountService.getFiberAccDetailsLite().subscribe((res) => {
            if (res != null) {
                this.accountType = res.accountGroupCode;
            }
        });
    }
    getPaymentMethod(recall) {
        this.loader = true;
        this.accountDetailService.getPaymentMethodInformation().subscribe((info) => {
            this.paymentInfo = info;
            if (!recall) {
                if (this.paymentInfo && (this.paymentInfo.bankAccount != null && this.paymentInfo.card != null)) {
                    if (this.paymentInfo.paymentType === 'check') {
                        this.paymentType = 'bank';
                    }
                    else {
                        this.paymentType = 'card';
                    }
                }
                else {
                    this.getSavedBankAccount();
                }
            }
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    canShowBankAccount() {
        this.loader = true;
        this.accountService.getPrimarySavedBankDetailsHS(true).subscribe((data) => {
            this.loader = false;
            this.showBankAccountOption = !!data;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getSavedBankAccount() {
        this.loader = true;
        this.accountService.getPrimarySavedBankDetailsHS(true).subscribe((data) => {
            if (!data) {
                this.loader = false;
                this.paymentType = 'card';
            }
            else {
                this.getSavedCardDetails();
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getSavedCardDetails() {
        this.loader = true;
        this.accountService.getPrimarySavedCardsHS(true).subscribe((res) => {
            if (res) {
                this.paymentType = 'card';
            }
            else {
                this.paymentType = 'bank';
            }
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
}
exports.CSHSPrimaryMethodComponent = CSHSPrimaryMethodComponent;
//# sourceMappingURL=hsprimarymethod.component.js.map